// extracted by mini-css-extract-plugin
export default {"banner":"CookieBanner_banner__frteI","text":"CookieBanner_text__NAgIj","link":"CookieBanner_link__HQINF","button":"CookieBanner_button__Klre+"};